import { Box, CircularProgress, Skeleton, TextField, Typography } from "@mui/material";
import apiManagerRoom from "api/manager-meeting";
import { ROLE, RenderEmailOrNameUser } from "pages/subtitles/components/constants";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import './SearchUserVMP.css';
import { AvatarUser } from '.';

const SearchUserVMP = (
    {
        userListRender, 
        setUserListRender, 
        userIdList = [], 
        roleParticipant = ROLE.PARTICIPANT, 
        placeholderSearch, 
        autoFocus = false,
        sharedUserIds = []
    }
) => {
    let loadingData = {
        "isLoading": true,
        "id": "",
        "roomId": "",
        "userName": "",
        "notificationType": 5,
        "processStatus": 0,
        "notifiedTime": "",
        "messageObject": "",
        "isSent": 1,
        "unixNotifiedTime": 1692587715
    }
    let noMoreData = {
        "lastNotification": true,
    }

    let noData = {
        "noData": true,
    }
    
    const [searchUser, setSearchUser] = useState('');
    const [userIdListRender, setUserIdListRender] = useState([]);
    const userInfo = useSelector((state) => state.userInfo.userInfo);
    const [userList, setUserList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [open, setOpen] = useState(false);
    const wrapperRef = useRef(null);
    const boxRef = useRef(null);
    const {t} = useTranslation();
    const [idLargestUser, setIdLargestUser] = useState(0);
    const limit = 5;
    const [maxLengthData, setMaxLengthData] = useState(false);
    const maxHeight = 230
    const autoFocuse = true
    const [moveIndex, setMoveIndex] = useState(0);
    const [chooseUser, setChooseUser] = useState(false);

    const handleEnterKey = () => {
        setChooseUser(true);
    }

    const handleSetMoveIndex = (key) => {
        if(key === 'ArrowDown'){
            setMoveIndex(prev => prev + 1)
            document.getElementsByClassName("list-user-chose")[0].scrollIntoView({ behavior: "smooth", block: 'nearest',inline: "nearest" });
        }
        if(key === 'ArrowUp' ){
            setMoveIndex(prev => {
                let index = prev;
                if(index >= 1){
                    return prev - 1;
                } else {
                    return prev
                }
            })
            document.getElementsByClassName("list-user-chose")[0].scrollIntoView({ behavior: "smooth", block: 'nearest', inline: "nearest" });
        }
    }

    const handleMouseMove = () => {
        document.getElementsByClassName('userListRenderClass')[0].style.pointerEvents = 'auto';
    }

    const handleKeyBoard = (event) => {
        if (event.key === 'ArrowDown' ) {
            document.getElementsByClassName('userListRenderClass')[0].style.pointerEvents = 'none';
            handleSetMoveIndex(event.key)
        } else if (event.key === 'ArrowUp') {
            document.getElementsByClassName('userListRenderClass')[0].style.pointerEvents = 'none';
            handleSetMoveIndex(event.key)
        } else if(event.key === "Enter"){
            handleEnterKey()
        }
    }

    const filterUserList = async (listUsers) => {
        let userIdOwner = userInfo?.id;
        let fetchUsersList = listUsers.filter(user =>
            user.id !== userIdOwner
            &&
            !userIdListRender.includes(user.id)
            &&
            !sharedUserIds.includes(user.id)
        );
        if (listUsers?.length < limit && listUsers?.length > 0) {
            setUserList([...fetchUsersList, noMoreData]);
        } else if(listUsers?.length === 0){
            setUserList([...fetchUsersList, noData]);
        } else if(listUsers?.length === limit && fetchUsersList.length < listUsers.length){
            setUserList([...fetchUsersList, loadingData]);
            setTimeout(() => {
                setCurrentPage(prev => prev + 1);
            }, 100)
        } else {
            setUserList([...fetchUsersList, loadingData]);
        }
        setIdLargestUser(listUsers[listUsers.length - 1]?.id);
        setMaxLengthData(false)
        setCurrentPage(0);
    }

    const fetchUsers = (data, correctUserName = false, id) => {
        if (correctUserName) {
            return apiManagerRoom.searchUserForRoom({ query: data, correctUserName: true });
        } else return apiManagerRoom.searchUserForRoom({ query: data, limit: limit, idLargestUser: id });
    };

    const timer = useRef(0);
    const debounce = (callback, delay) => {
        return function(...params) {
            clearTimeout(timer.current)
            timer.current = setTimeout(() => {
            callback(...params);
            }, delay)
        }
    }

    const fetchSearchUser = (value) => {
        if(value?.length > 0){
            fetchUsers(value, false, 0)
            .then(async (r) => {
                filterUserList(r.data);
            })
            .catch(e => {
                console.log(e);
            })
            .finally(() => {
                setLoading(false);
            })
        } else {
            setIdLargestUser(0);
            setMaxLengthData(false)
            setCurrentPage(0);
        }
    }

    const callSearchUser = debounce(fetchSearchUser, 500);

    const handleChooseUser = (user) => {
        setUserListRender([...userListRender, user]);
        setOpen(false);
        setSearchUser('');
        // setUserNameListRender(username => [...username, user?.username]);
        setUserIdListRender(userId => [...userId, user?.id])
        setUserList([]);
        setIdLargestUser(0);
        setMaxLengthData(false)
        setCurrentPage(0)
        setMoveIndex(0);
        document.getElementById("myTextField").focus();
    }

    function useOutsideAlerter(ref) {
        useEffect(() => {
            /**
             * Close paper if clicked on outside of element
             */
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setTimeout(() => {
                        setOpen(false);
                        setMoveIndex(0)
                    }, 300)
                }
            }
            // Bind the event listener
            document.addEventListener('mousedown', handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener('mousedown', handleClickOutside);
            };
        }, [ref]);
    }

    useOutsideAlerter(boxRef);

    const setCurrentPageWhenScroll = () => {
        setCurrentPage(prevCurrentPage => prevCurrentPage + 1)
    }

    const handleCurrentPageWhenScroll = debounce(setCurrentPageWhenScroll, 300);

    const trackLoadCourses = () => {
        const el = document.getElementsByClassName("userListRenderClass")[0];
        try {
            if (Math.ceil(el.scrollTop) + el.offsetHeight >= el.scrollHeight - 300) {
                handleCurrentPageWhenScroll();
            }
        } catch (e) {
            el.removeEventListener("scroll", trackLoadCourses);
        }
    };

    useEffect(() => {
        if(chooseUser){
            if(userList.filter(user => user?.email).length > 0){
                handleChooseUser(JSON.parse(document.getElementsByClassName("list-user-chose")[0].getAttribute('valueuser')));
            }
            setChooseUser(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chooseUser])

    useEffect(() => {
        document.getElementsByClassName('userListRenderClass')[0]?.addEventListener('scroll', trackLoadCourses)

        document.addEventListener('mousemove', handleMouseMove)

        document.addEventListener('keydown', handleKeyBoard);

        return () => {
            document.getElementsByClassName('userListRenderClass')[0]?.removeEventListener('scroll', trackLoadCourses)
            document.removeEventListener('mousemove', handleMouseMove)
            document.removeEventListener('keydown', handleKeyBoard)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        userIdListRender?.forEach(userId => {
            const found = userListRender?.find((element) => element?.id === userId);
            if(found){
                //Don't do anything
            } else {
                setUserIdListRender(userIdListRender?.filter(user => user !== userId))
            }
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userListRender])

    useEffect(() => {
        if(userIdList?.length > 0 ){
            setUserIdListRender([...userIdListRender, ...userIdList])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userIdList])
    
    useEffect(() => {
        if(!open && searchUser?.length > 0){
            setOpen(true);
        }
        if(searchUser?.length === 0){
            setOpen(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchUser])

    useEffect(() => {
        if (currentPage > 0 && !maxLengthData) {
            fetchUsers(searchUser, false, idLargestUser)
                .then(async (res) => {
                    let userIdOwner = userInfo?.id;
                    let fetchUsersList = res?.data.filter(user =>
                        user.id !== userIdOwner
                        &&
                        !userIdListRender.includes(user.id)
                    );
                    if (res?.data?.length < limit) {
                        setUserList(prevDatas => {
                            return [...prevDatas.filter(data => data?.lastNotification !== true).filter(data => data?.isLoading !== true), ...fetchUsersList, noMoreData]
                        })
                        setMaxLengthData(true)
                        setIdLargestUser(res?.data[res?.data?.length - 1]?.id)
                    } else if(res?.data?.length > 0){
                        setUserList(prevDatas => {
                            return [...prevDatas.filter(data => data?.isLoading !== true).filter(data => data?.lastNotification !== true), ...fetchUsersList, loadingData]
                        })
                        setIdLargestUser(res?.data[res?.data?.length - 1]?.id)
                    } else {
                        setUserList(prevDatas => {
                            return [...prevDatas.filter(data => data?.lastNotification !== true).filter(data => data?.isLoading !== true), noMoreData]
                        })
                        setMaxLengthData(true)
                    }
                })
                .catch(e => {
                    console.log(e);
                })
                .finally(() => {
                    setLoading(false);
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage])

    return(
        <Box id={"search-user-box"} ref={boxRef} sx={{position: 'relative', width: '100%'}}>
            <TextField 
                id={"myTextField"}
                autoFocus={autoFocuse}
                ref={wrapperRef}
                fullWidth 
                value={searchUser}
                placeholder={placeholderSearch || t('room.placeholder.searchNameOrEmail')}
                onClick={() => {
                   searchUser?.length > 0 && setOpen(true)
                }}
                onChange={(event) => {
                    setLoading(true);
                    setSearchUser(event.target.value);
                    callSearchUser(event.target.value);
                }}
            />
            <div 
                className="userListRenderClass"
                style={{
                    position: 'absolute', 
                    width: 'inherit', 
                    zIndex: '1000', 
                    backgroundColor: "#fff",
                    maxHeight: `${maxHeight}px`,
                    overflow: 'auto',
                    top: '42px',
                    boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)',
                    borderRadius: '4px'
                }}
            >
                {
                    open &&loading &&
                    <Box sx={{display: 'flex', alignItems: 'center', padding: '0.5rem'}}>
                        <CircularProgress sx={{height: '20px !important', width: '20px !important'}}/>
                        <Typography sx={{marginLeft: '0.5rem'}}>{t('search-user.searching')}</Typography>
                    </Box>
                }
                {
                    open && !loading && searchUser?.length > 0 &&
                    userList?.map((user, index) => {
                        if(user?.isLoading){    
                            return (
                                <div
                                    style={{
                                        borderBotton: '1px solid #dedede',
                                        display: 'flex',
                                        padding: '0.5rem'
                                    }}
                                >
                                    <div>
                                        <Skeleton variant="circular" width={40} height={40} />
                                    </div>
                                    <div style={{width: '80%', marginLeft: '1rem'}}>
                                        <Skeleton sx={{width: '50%'}}/>
                                        <Skeleton />
                                    </div>
                                </div>
                            )
                        } else if(user?.noData){
                            return (
                                <div style={{padding: '0.5rem', textAlign: 'center'}}>
                                    {t("search-user.no-data")}
                                </div>
                            )
                        } else if(user?.lastNotification && !user?.noData){
                            return (
                                <div style={{padding: '0.5rem', textAlign: 'center'}}>
                                    {t("search-user.no-more-data")}
                                </div>
                            )
                        } else {
                            return (
                                <li 
                                    valueUser={JSON.stringify(user)} 
                                    index={index} 
                                    key={index} 
                                    className={`list-user ${moveIndex === index ? 'list-user-chose': ''}`} 
                                    style={{listStyleType: "none", padding: '0.5rem'}} onClick={() => handleChooseUser(user)}
                                    onMouseOver={() => {setMoveIndex(index)}}
                                > 
                                    <div style={{display: 'flex', alignItems: 'center', fontSize: '14px', cursor: 'pointer'}}>
                                        <AvatarUser user={user}/>
                                        {
                                            user?.name ?
                                            (
                                                <div style={{display: "flex", flexDirection: 'column', marginLeft: 1}}>
                                                    {user?.name && <RenderEmailOrNameUser name={user?.name}/>}
                                                    {user?.email && <RenderEmailOrNameUser  name={user?.email}/>}
                                                </div>
                                            ) :
                                            (
                                                <div style={{display: "flex", padding: '10.5px 0', flexDirection: 'column', marginLeft: 1}}>
                                                    {user?.email && <RenderEmailOrNameUser  name={user?.email}/>}
                                                </div>
                                            )
                                        }
                                    </div>
                                </li>
                            )
                        }
                    })
                }
            </div>
        </Box>
    )
}

export default SearchUserVMP;